export default __webpack_public_path__ + "static/media/best-vegan-food-brands.b6f4d915.png";